import { render, staticRenderFns } from "./Cart.vue?vue&type=template&id=16c76395&scoped=true"
import script from "./Cart.vue?vue&type=script&lang=js"
export * from "./Cart.vue?vue&type=script&lang=js"
import style0 from "./Cart.vue?vue&type=style&index=0&id=16c76395&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c76395",
  null
  
)

export default component.exports
import {QSpinner,QBtn,QSlideItem,QIcon,QCheckbox,QDialog,QCard,QCardSection,QInput,QSelect,QCardActions,QColor,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QSpinner,QBtn,QSlideItem,QIcon,QCheckbox,QDialog,QCard,QCardSection,QInput,QSelect,QCardActions,QColor})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
